var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 background-color-toolbar",attrs:{"fluid":""}},[_c('v-overlay',{staticStyle:{"left":"-57px"},attrs:{"color":"#106c68","z-index":"12"}},[_c('span',{staticClass:"loader"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }